import { render, staticRenderFns } from "./ProductSubCategories.vue?vue&type=template&id=2fde5dbe&"
import script from "./ProductSubCategories.vue?vue&type=script&lang=js&"
export * from "./ProductSubCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProductSubCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports